module.exports = __webpack_public_path__ + "static/img/step-1.554e1a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/assets/img/tuto-unlock-popup/safari/step-1.png
// module id = 956
// module chunks = 0